import { Changeable } from 'common';
import { NavigationService } from '../services/navigation.service';
import { MessageService } from 'base';

export abstract class ChangeableContainer implements Changeable {

	protected children: Changeable[] = [];

	constructor(protected navService: NavigationService,
				protected messageService: MessageService) {
		return;
	}

	//
	// Changeable
	//

	public get tempChanges(): boolean {
		return this.children.some((child: Changeable) => (!!child ? child.tempChanges : false));
	}

	public get tempChangesValid(): boolean {
		return this.children.every((child: Changeable) => {
			if (!!child && child.tempChanges) {
				return child.tempChangesValid;
			}
			else {
				return true;
			}
		});
	}

	public get invalidTempChanges(): string[] {
		let result = [];

		this.children.forEach((child: Changeable) => {
			if (!!child && child.tempChanges && !child.tempChangesValid) {
				Array.prototype.push.apply(result, child.invalidTempChanges);
			}
		});

		return result;
	}

	// PRE: tempChanges && tempChangesValid
	public applyTempChanges(): void {
		this.children.forEach((child: Changeable) => {
			if (!!child && child.tempChanges) {
				if (child.tempChangesValid) {
					child.applyTempChanges();
				}
				else {
					console.assert(false, "applyTempChanges called in invalid state");
				}
			}
		});
	}

	// PRE: tempChanges
	public discardTempChanges(): void {
		this.children.forEach((child: Changeable) => {
			if (!!child && child.tempChanges) {
				child.discardTempChanges();
			}
		}, this);
	}

	//
	// Save / Navigation
	// NOTE: Navigation initiates an implicit "Save" operation, if necessary
	//

	public showInvalidTempChangesDialog: boolean = false;
	public tabsWithErrors: string[] = [];
	private navUrl: string = null;

	// navUrl: Target URL of user's navigation
	// Returns boolean indicating whether or not navigation should be allowed by the guard
	public onSave(navUrl: string = null): boolean {
		if (this.tempChanges) {
			if (!this.tempChangesValid) {
				// There are invalid temp changes in one or more tabs
				this.tabsWithErrors = this.invalidTempChanges;
				this.navUrl = navUrl;
				this.showInvalidTempChangesDialog = true;

				return false;
			}
			else {

				this.applyTempChanges();
			}
		}

		this.save();

		return true;
	}

	public onDiscardTempChanges(): void {
		let url = this.navUrl;

		this.showInvalidTempChangesDialog = false;
		this.tabsWithErrors = [];
		this.navUrl = null;

		this.discardTempChanges();

		this.save();

		if (url) {
			this.navService.selectUrl(url);
		}
	}

	public onCancelSave(): void {
		this.showInvalidTempChangesDialog = false;
		this.tabsWithErrors = [];
		this.navUrl = null;
	}

	public abstract isSaveEnabled(): boolean;

	protected abstract save(): void;

}
